__turbopack_context__.v({
  "blok-big-title": "MarqueeBlok-module__UELFoq__blok-big-title",
  "blok-subtitle": "MarqueeBlok-module__UELFoq__blok-subtitle",
  "blok-title": "MarqueeBlok-module__UELFoq__blok-title",
  "marquee": "MarqueeBlok-module__UELFoq__marquee",
  "marquee__element": "MarqueeBlok-module__UELFoq__marquee__element",
  "scroll-first": "MarqueeBlok-module__UELFoq__scroll-first",
  "scroll-second": "MarqueeBlok-module__UELFoq__scroll-second",
  "second_marquee": "MarqueeBlok-module__UELFoq__second_marquee",
});
